import { render } from "./PromotionDetail.vue?vue&type=template&id=057cbd40&scoped=true&ts=true"
import script from "./PromotionDetail.vue?vue&type=script&lang=ts"
export * from "./PromotionDetail.vue?vue&type=script&lang=ts"

import "./PromotionDetail.vue?vue&type=style&index=0&id=057cbd40&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-057cbd40"]])

export default __exports__